class ShippingPointRequest{
    ShippingPointURL(location){
        return process.env.REACT_APP_BASEURL+"GetShippingPoint/"+location;
    }
}
export const {ShippingPointURL}=new ShippingPointRequest();